import React from "react";
import Chip from "@mui/material/Chip";

const CardSubtitle = ({variant, subtitle}) => {
    return (
        <div className={`custom-card-subtitle ${variant}`}>
            {variant === "default" && <div>{subtitle}</div>}
            {variant === "pill" && <Chip className={"chip"} variant="filled" size="medium" label={subtitle} />}
        </div>
    );
};

export default CardSubtitle;
